import React from "react";
import { RequiredDocAnswerableQuestionProps } from "./RequiredDocAnswerableQuestion";
import { RequiredDocRadio } from "./RequiredDocRadio";

type Props = RequiredDocAnswerableQuestionProps;

const RequiredDocYesNo = (props: Props) => {
  return (
    <RequiredDocRadio
      currentAnswer={props.currentAnswer}
      handleOnInsertAnswer={props.handleOnInsertAnswer}
      questionId={props.questionId}
      questionText={props.questionText}
      prefilledAnswer={props.prefilledAnswer}
      possibleAnswers={["Yes", "No"]}
      showOtherOption={false}
      isRequired={props.isRequired}
      isValid={props.isValid}
      readonly={props.readonly}
      notes={props.notes}
    />
  );
};

export default RequiredDocYesNo;
